export class IntervalReportModel {
  constructor(data = {}) {
    const {
      id,
      name,
      accountId,
      advertiserId,
      description,
      insertionOrderName,
      status,
      lastSendDate,
      query,
      notification,
    } = data
    this.id = id
    this.name = name
    this.accountId = Number(accountId)
    this.advertiserId = Number(advertiserId)
    this.description = description
    this.insertionOrderName = insertionOrderName
    this.status = status
    this.lastSendDate = lastSendDate
    this.query = IntervalReportQueryModel.assign(query)
    this.notification = IntervalReportNotificationModel.assign(notification)
  }

  static assign(data) {
    return new IntervalReportModel(data)
  }
}

export class IntervalReportQueryModel {
  constructor(data = {}) {
    const {
      insertionOrderIds = [],
      dimension,
      interval,
      period,
      isIncludeBudget,
      isIncludeCreative,
    } = data
    this.insertionOrderIds = insertionOrderIds
    this.dimension = dimension
    this.interval = interval
    this.period = period
    this.isIncludeBudget = isIncludeBudget
    this.isIncludeCreative = isIncludeCreative
  }

  static assign(data) {
    return new IntervalReportQueryModel(data)
  }
}

export class IntervalReportNotificationModel {
  constructor(data = {}) {
    const { sendInterval, emails, closingDate, encode } = data
    this.sendInterval = sendInterval
    this.emails = emails
    this.closingDate = closingDate
    this.encode = encode
  }

  static assign(data) {
    return new IntervalReportNotificationModel(data)
  }
}
